import { 
    userSettings
} from '@/globals/userSettings';

import stopAnimations from "@/tools/stopAnimations";
import readableFont from "@/tools/readableFont";
import bigCursor from "@/tools/bigCursor";
import highlightTitle from "@/tools/highlightTitle";
import readingGuide from "@/tools/readingGuide";
import highlightLinks from "@/tools/highlightLinks";
import adjustLetterSpacing from "@/tools/adjustLetterSpacing";
import adjustLineHeight from "@/tools/adjustLineHeight";
import adjustFontWeight from "@/tools/adjustFontWeight";
import alignLeft from "@/tools/alignLeft";
import adjustFontSize from '@/tools/adjustFontSize';

export default function renderTools() {
    const states = userSettings?.states;
    highlightTitle(states['highlight-title']);
    highlightLinks(states['highlight-links']);
    const fontSize = Number(states?.fontSize) || 1;
    adjustFontSize(fontSize);

    adjustLetterSpacing(states['letter-spacing']);
    adjustLineHeight(states['line-height']);
    adjustFontWeight(states['font-weight']);

    readableFont(states['readable-font']);

    readingGuide(states['readable-guide']);
    stopAnimations(states['stop-animations']);
    bigCursor(states['big-cursor']);
    alignLeft(states['align-left']);
}